<template>
  <div>
    <b-modal
      id="empresaSemEmailList"
      ref="empresaSemEmailList"
      no-close-on-backdrop
      no-stacking
      size="lg"
      :no-enforce-focus="true"
    >
      <div slot="modal-title">
        <h4>Cadastro de email por empresa</h4>
        <fieldset class="font-weight-bold text-muted small">
          Informe o email da empresa e salve para enviar o documento e atualizar o cadastro.
        </fieldset>
      </div>

      <div style="margin-bottom: 10px;">
        <h5>
          Os e-mails informados serão automaticamente associados ao cadastro da empresa
        </h5>
        Ao clicar em 'OK', apenas empresas com e-mail preenchido serão consideradas, e o processo seguirá normalmente.
      </div>

      <b-row>
        <b-col>
          <div style="max-height: 600px; overflow-y: auto;">
            <tabela-repeticao
              v-model="value"
              :colunas="colunas"
              :somente-visualizacao="true"
            >
              <template #visualizacao="{slotScope: {key, item, valor}}">
                <validation-provider
                  v-if="key === 'email'"
                  #default="{ errors }"
                  name="Email de contato"
                  rules="email"
                >
                  <b-form-input
                    id="loginInput"
                    v-model="item.email[0]"
                    name="login-email"
                    :state="errors.length > 0 ? false : null"
                    placeholder="pessoa@empresa.com.br"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>

                <span
                  v-else-if="key === 'razaoSocial'"
                >
                  {{ formatarRazaoSocial(valor, 50) }}
                </span>

                <span
                  v-else
                  class="ml-50"
                >
                  {{ valor }}
                </span>
              </template>
            </tabela-repeticao>
          </div>
        </b-col>
      </b-row>

      <template #modal-footer>
        <b-button
          variant="primary"
          class="btn-sm"
          @click="confirmarEnvio"
        >
          Ok
        </b-button>
      </template>

    </b-modal>
  </div>
</template>

<style lang="scss">
.modal:nth-of-type(even) {
    z-index: 1052 !important;
}
.modal-backdrop.show:nth-of-type(even) {
    z-index: 1051 !important;
}
</style>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'EmpresasSemEmail',
  components: {
    ValidationProvider,
    TabelaRepeticao: () => import('@pilar/components/tabela-repeticao/TabelaRepeticao.vue'),
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      colunas: [
        {
          key: 'razaoSocial', label: 'Razão Social',
        },
        {
          key: 'cadastroFederal', label: 'CNPJ/CPF',
        },
        {
          key: 'email', label: 'E-mail',
        }],
    }
  },
  methods: {
    formatarRazaoSocial(nome, tamanhoMaximo) {
      if (!nome) {
        return nome
      }
      if (nome.length - 3 > tamanhoMaximo) {
        const nomeFormatado = `${nome.substring(0, tamanhoMaximo)}...`
        return nomeFormatado
      }
      return nome
    },
    async confirmarEnvio() {
      const erros = []

      this.value.forEach((empresa, i) => {
        const email = empresa.email?.[0]
        if (!this.validator(email)) {
          erros.push(`Linha ${i + 1}: Email inválido (${email})`)
        }
      })

      if (erros.length > 0) {
        this.$erro('Corrija os emails inválidos antes de continuar.')
        return
      }

      this.$emit('confirmar-envio', this.value)
      this.$refs.empresaSemEmailList.hide()
    },
    show() {
      this.$refs.empresaSemEmailList.show()
    },
    validator(tag) {
      if (!tag || tag.trim() === '') {
        return true
      }

      const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(tag)
    },
  },
}

</script>
